import { generateOptions, OperationReportType } from '@constants';
import React, { memo, useState } from 'react';
import trans from 'translation';
import { KContainer, KGrid, KInput } from 'uikit';

import ExpCTOTimeslotBooking from './ExpCTOTimeslotBooking';
import ExportEmptyYardPickupDate from './ExpEmptyYardPickupDate';
import ExportWarehouseEmptyDropOff from './ExpWarehouseEmptyDropOff';
import ExpWarehouseFullPickup from './ExpWarehouseFullPickup';
import ImpCTOTimeslotBooking from './ImpCTOTimeslotBooking';
import ImportEmptyYardDehireDate from './ImpEmptyYardDehireDate';
import ImpWarehouseDelivery from './ImpWarehouseDelivery';
import ImportWarehouseEmptyPickup from './ImpWarehouseEmptyPickup';

const ReportOperation = () => {
  const [reportCode, setReportCode] = useState<string | undefined>('');

  return (
    <KContainer.Card marginT="0.25rem">
      <KGrid.Container>
        <KGrid.Item xs={6}>
          <KInput.TextField
            name="report"
            label={trans('report')}
            value={reportCode}
            options={generateOptions(OperationReportType)}
            onChange={e => setReportCode(e.target.value)}
            // maxW={600}
          />
        </KGrid.Item>

        {!!reportCode && (
          <KGrid.Item xs={12}>
            <KContainer.RenderWhen>
              <KContainer.RenderWhen.If
                isTrue={
                  reportCode === OperationReportType.IMP_WAREHOUSE_DELIVERY
                }
              >
                <ImpWarehouseDelivery />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode === OperationReportType.EXP_WAREHOUSE_FULL_PICKUP
                }
              >
                <ExpWarehouseFullPickup />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode === OperationReportType.EXP_CTO_TIMESLOT_BOOKING
                }
              >
                <ExpCTOTimeslotBooking />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode === OperationReportType.IMP_CTO_TIMESLOT_BOOKING
                }
              >
                <ImpCTOTimeslotBooking />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode ===
                  OperationReportType.EXPORT_WAREHOUSE_EMPTY_DROP_OFF
                }
              >
                <ExportWarehouseEmptyDropOff />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode ===
                  OperationReportType.EXPORT_EMPTY_YARD_PICK_UP_DATE
                }
              >
                <ExportEmptyYardPickupDate />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode ===
                  OperationReportType.IMPORT_EMPTY_YARD_DEHIRE_DATE
                }
              >
                <ImportEmptyYardDehireDate />
              </KContainer.RenderWhen.If>

              <KContainer.RenderWhen.If
                isTrue={
                  reportCode ===
                  OperationReportType.IMPORT_WAREHOUSE_EMPTY_PICK_UP
                }
              >
                <ImportWarehouseEmptyPickup />
              </KContainer.RenderWhen.If>
            </KContainer.RenderWhen>
          </KGrid.Item>
        )}
      </KGrid.Container>
    </KContainer.Card>
  );
};

export default memo(ReportOperation);
